export const APP_VERSION = {
  "version": "0.0.1",
  "buildDate": "2026-11-04T16:19:01.823Z",
  "env": "development"
};
